import { z as e } from "zod";
const r = "verity-proxy-external-message", t = "verity-proxy-background-message", a = e.object({
  id: e.string()
}), n = a.extend({
  type: e.literal(r)
}), o = n.extend({
  handler: e.string(),
  params: e.any()
}), c = n.extend({
  message: e.any()
}), l = e.union([o, c]), s = a.extend({
  type: e.literal(t)
}), d = e.discriminatedUnion("success", [
  s.extend({
    success: e.literal(!0),
    result: e.any()
  }),
  s.extend({
    success: e.literal(!1),
    error: e.unknown().optional()
  })
]);
export {
  t as PROXY_BACKGROUND_MESSAGE_TYPE,
  r as PROXY_EXTERNAL_MESSAGE_TYPE,
  d as ProxyBackgroundMessageSchema,
  l as ProxyExternalMessageSchema
};
